import { ImgLoadedResult } from '@/components/img'

/** 显示兜底背景图控制类 */
export class ExhibitFallbackBg {
  /** 是否显示背景图(私有) */
  private _isShow = true
  /** 是否显示背景图(只读属性) */
  public get isShow() {
    return this._isShow
  }
  /** 设置是否背景图,依赖广告图加载情况 */
  public setIsShowBgByAdvertiser = (loadedResult: ImgLoadedResult) => {
    if (loadedResult === ImgLoadedResult.Success) {
      this._isShow = false
    } else {
      this._isShow = true
    }
  }
}
